import React from "react";
import Modal from "react-modal";
import "./ModalWrapper.scss";

Modal.setAppElement("#root");
Modal.defaultStyles!.overlay!.backgroundColor = "rgba(0,0,0,0.4)";
const mediaQuery = window.matchMedia("(max-width: 1024px)");
export const ModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    color: "white",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "rgba(0,0,0,0.9)",
    width: mediaQuery.matches ? "70%" : "25%",
    minHeight: "20%",
    maxHeight: "80%",
    padding: "0px",
  },
};

type Props = {
  children: any;
  setShowModal: Function;
  showModal: boolean;
  contentLabel: string;
};

function ModalWrapper({ children, setShowModal, showModal, contentLabel }: Props) {
  return (
    <Modal contentLabel={contentLabel} onRequestClose={() => setShowModal(false)} isOpen={showModal} style={ModalStyles}>
      {children}
    </Modal>
  );
}

export default ModalWrapper;
